export { cn } from '@/components/ui/design-system/lib/utils';

export const formatTimeToMinutesSeconds = (time: number) => {
  if (Number.isNaN(time) || !Number.isFinite(time)) {
    return '0:00';
  }
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const normalizeText = (text: string): string => {
  return text
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
    .toLowerCase();
};

export function isoTimeToSeconds(isoTime: string): number {
  const timeRegex = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/;
  const match = isoTime.match(timeRegex);

  if (!match || !match[1] || !match[2]) {
    throw new Error(`Invalid time format: ${isoTime}. Expected HH:mm format.`);
  }

  const hours = Number.parseInt(match[1], 10);
  const minutes = Number.parseInt(match[2], 10);

  return hours * 3600 + minutes * 60;
}

export function secondsToIsoTime(seconds: number): string {
  if (seconds < 0 || seconds > 86399) {
    throw new Error(`Invalid seconds value: ${seconds}. Must be between 0 and 86399.`);
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

export const formatIntegrationName = (name: string): string => {
  return name
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const reorder = <T>(list: T[], startIndex: number, endIndex: number): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  if (removed) {
    result.splice(endIndex, 0, removed);
  }

  return result;
};

export const formatFileSize = (bytes?: number) => {
  if (!bytes) {
    return '';
  }

  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(unitIndex > 0 ? 1 : 0)} ${units[unitIndex]}`;
};
